// @flow
import type { Store } from 'redux';
import { addAlert, addConfirm } from 'esm-web-pro/redux/workflow/msgDialog';


const alertCallback = (data: {
    message: string,
    execution_id: string,
    title: ?string,
    action_label: ?string,
    size: ?string,
}, context: { store: Store }) => {
    context.store.dispatch(addAlert(
        data.execution_id,
        data.message,
        data.title,
        data.action_label,
        data.size,
    ));
};


const confirmCallback = (data: {
    message: string,
    execution_id: string,
    key: string,
    actions: {
        [string]: {
            label: string,
            type?: 'positive' | 'negative',
        }
    },
    title: ?string,
    size: ?string,
}, context: { store: Store }) => {
    context.store.dispatch(addConfirm(
        data.execution_id,
        data.message,
        data.key,
        data.actions,
        data.title,
        data.size,
    ));
};


export const alert = {
    async: false,
    func: alertCallback,
};


export const confirm = {
    async: false,
    func: confirmCallback,
};
